import React, { PropsWithChildren } from "react";
import { TabsProvider } from "./context";

import "./tabs.css";

export function Tabs({
	children,
	value,
	defaultValue,
}: PropsWithChildren<{
	value?: string;
	defaultValue?: string;
}>) {
	return (
		<TabsProvider value={value} defaultValue={defaultValue}>
			<div className="tabs">{children}</div>
		</TabsProvider>
	);
}
